require(['BuildStatus/main_application'], function () {});
